function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import A from '@adsk/alloy-react-a';
import { Box } from '@adsk/alloy-react-box';
import { displayDate, displayTime } from '@adsk/alloy-react-datetime';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
const MaintenanceState = _ref => {
  let {
    name,
    endDate,
    children
  } = _ref;
  const {
    T,
    locale
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require(`./i18n/${locale}.json`);
  });
  const description = T.translate(endDate ? 'MAINTENANCE_DESCRIPTION_WITH_END_DATE' : 'MAINTENANCE_DESCRIPTION', _objectSpread({
    context: (name !== null && name !== void 0 ? name : '').length,
    name
  }, endDate ? {
    endTime: displayTime(endDate, {
      locale
    }),
    endDate: displayDate(endDate, {
      format: 'numeric',
      locale
    })
  } : {}));
  return /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(EmptyState, {
    size: EmptyState.SIZES.MEDIUM,
    illustrationType: EmptyState.ILLUSTRATION_TYPES.CRANE_CONSTRUCTION,
    title: T.translate('MAINTENANCE_TITLE'),
    description: description
  }, children !== null && children !== void 0 ? children : /*#__PURE__*/React.createElement(A, {
    style: theme.typography.bodyMedium,
    href: "https://health.autodesk.com/"
  }, T.translate('MAINTENANCE_DEFAULT_HREF_TEXT'))));
};
MaintenanceState.displayName = 'MaintenanceState';
MaintenanceState.propTypes = {
  /** The name of the tool being maintained */
  name: PropTypes.string,
  /** The end date to show the maintenance page for */
  endDate: PropTypes.instanceOf(Date)
};
export default MaintenanceState;
//# sourceMappingURL=MaintenanceState.js.map